import * as React from "react";
import Svg, { Path, Defs, G, LinearGradient, Stop } from "react-native-svg";

function FillAddress(props) {
  return (
    <Svg
      width="78"
      height="53"
      viewBox="0 0 78 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M28.6748 44.9595H13.3485C13.3485 44.9595 8.79582 44.7093 8.89818 46.0697C9.01818 47.6701 26.6549 46.6159 27.9441 47.6216C29.2333 48.6273 29.9083 49.8116 32.2076 50.3868C34.507 50.962 38.8646 49.4992 51.0785 51.1003C58.4687 49.6023 34.5201 44.9595 28.6748 44.9595Z"
        fill="#5AD2D6"
      />
      <Path
        d="M10.4072 3.23419C10.3868 0.500731 15.6401 0.0996057 15.5782 1.53751L25.0093 1.57165C26.1003 1.58701 26.9804 2.56166 26.9777 3.74899L26.8535 43.3962C26.8497 44.5569 25.9731 45.4995 24.8945 45.4998L14.9049 45.5476C14.8087 45.7412 14.6282 45.9166 14.3436 46.0621C11.5484 46.0402 10.2778 44.9532 10.2668 43.5539C10.1623 43.2958 10.2944 3.74831 10.4072 3.23419Z"
        fill="#027273"
      />
      <Path
        d="M11.4846 19.504C11.5393 19.5056 11.5938 19.4964 11.6448 19.477C11.6959 19.4577 11.7426 19.4284 11.7821 19.3911C11.8216 19.3537 11.8532 19.309 11.875 19.2594C11.8969 19.2099 11.9085 19.1566 11.9093 19.1026L11.9999 8.75113C11.9999 8.63988 11.9559 8.53301 11.8773 8.4533C11.7987 8.37359 11.6917 8.32734 11.579 8.3244C11.5237 8.32276 11.4686 8.33207 11.4169 8.35177C11.3653 8.37147 11.3182 8.40117 11.2784 8.43912C11.2385 8.47708 11.2068 8.52251 11.185 8.57275C11.1632 8.62299 11.1519 8.67703 11.1516 8.73167L11.0662 19.0838C11.0666 19.1939 11.1106 19.2994 11.1888 19.3779C11.2669 19.4565 11.3731 19.5017 11.4846 19.504Z"
        fill="#013F40"
      />
      <Path
        d="M14.51 46.0704L26.8014 46.0568C27.9184 46.0568 28.8272 45.0924 28.8313 43.8982L28.9793 3.12271C28.9838 1.90158 28.0716 0.900645 26.9411 0.887673L14.6138 0.729612C13.4743 0.716981 12.5482 1.70153 12.5461 2.92846L12.4731 43.8965C12.4725 45.0947 13.383 46.0687 14.51 46.0704Z"
        fill="#03C0C2"
      />
      <Path
        d="M14.2617 45.7796C14.3366 45.7899 14.4122 45.795 14.4879 45.795L26.7765 45.7608C27.7365 45.7608 28.5256 44.9139 28.5291 43.8713L28.675 3.13916C28.6788 2.07302 27.8869 1.19533 26.9155 1.18338L14.5916 1.00586C14.5636 1.00586 14.5349 1.00586 14.5065 1.00586C14.2786 1.01556 14.0551 1.07074 13.8494 1.16808C13.6437 1.26542 13.4601 1.4029 13.3097 1.57221C12.9821 1.93994 12.8033 2.41395 12.8075 2.90361L12.7318 43.9167C12.7301 44.8596 13.3854 45.6605 14.2617 45.7796Z"
        fill="#0D0D0D"
      />
      <Path
        d="M13.4425 3.125L13.3602 43.9838L27.9323 43.9828L28.0716 3.24346L13.4425 3.125Z"
        fill="white"
      />
      <Path
        d="M28.5914 7.01758H10.8164V45.3645H28.5914V7.01758Z"
        fill="#E6E6E6"
      />
      <Path
        d="M30.7584 40.5586L1.92834 31.9257L3.07023 30.9883L30.1581 37.9419L30.7584 40.5586Z"
        fill="#04F2F5"
      />
      <Path
        d="M1.6594 31.9762L1.4873 32.5625L34.2911 41.9462L34.4632 41.3599L1.6594 31.9762Z"
        fill="white"
      />
      <Path
        d="M17.3719 22.2153C16.856 22.1639 16.3361 22.1639 15.8202 22.2153C13.4278 22.4519 11.3733 23.8103 11.0656 25.595C10.727 27.5566 12.5872 29.3362 15.4014 29.6766C15.7112 29.7143 16.023 29.7332 16.3351 29.7333C16.6493 29.7331 16.9632 29.7142 17.2751 29.6766C20.1128 29.3352 22.0957 27.5566 21.8928 25.595C21.7088 23.8113 19.7483 22.4519 17.3719 22.2153ZM17.2927 28.3568C16.9914 28.4073 16.6864 28.4325 16.3808 28.4323C16.0774 28.4327 15.7745 28.4075 15.4754 28.3568C13.6799 28.0537 12.4789 26.896 12.6511 25.594C12.8126 24.3729 14.1426 23.4092 15.7666 23.1722C16.0307 23.1335 16.2974 23.1141 16.5644 23.1142C16.8306 23.114 17.0965 23.1334 17.3598 23.1722C18.9671 23.4092 20.2301 24.3729 20.3079 25.594C20.3898 26.896 19.1093 28.0526 17.2927 28.3568Z"
        fill="#FFD84F"
      />
      <Path
        d="M17.433 17.4746L17.36 23.1733C17.0967 23.1345 16.8309 23.1151 16.5646 23.1153C16.2976 23.1152 16.031 23.1346 15.7668 23.1733L16.0867 17.4746H17.433Z"
        fill="#FFD84F"
      />
      <Path
        d="M31.9414 26.191H20.6972C20.7467 25.9962 20.7642 25.7948 20.749 25.5946C20.7336 25.396 20.687 25.201 20.6107 25.0166H31.5254L31.9414 26.191Z"
        fill="#FFD84F"
      />
      <Path
        d="M16.3478 29.3794C16.6612 29.3797 16.9738 29.3505 17.2815 29.292L17.1131 43.995H14.6886L15.4235 29.292C15.728 29.3506 16.0376 29.3798 16.3478 29.3794Z"
        fill="#FFD84F"
      />
      <Path
        d="M10.0106 21.231H7.21851L7.63176 19.874H10.556L10.0106 21.231Z"
        fill="white"
      />
      <Path
        d="M13.4346 21.231H10.6421L11.2172 19.874H14.1414L13.4346 21.231Z"
        fill="white"
      />
      <Path
        d="M15.4183 19.874H14.6872L13.9558 21.231H15.3208L15.4183 19.874Z"
        fill="white"
      />
      <Path
        d="M9.43564 22.779H6.79395L7.16466 21.5674H9.92428L9.43564 22.779Z"
        fill="white"
      />
      <Path
        d="M12.6871 22.7336L12.7019 22.7271L13.3082 21.5664H10.5475L10.0322 22.778H12.5933C12.6252 22.7636 12.657 22.7483 12.6871 22.7336Z"
        fill="white"
      />
      <Path
        d="M14.4014 22.1942C14.684 22.1468 14.9703 22.14 15.2556 22.1376L15.2947 21.5938H13.7606L13.2765 22.4916C13.6417 22.3596 14.0182 22.2601 14.4014 22.1942Z"
        fill="white"
      />
      <Path
        d="M8.90234 24.1H6.38928L6.72438 23.0059H9.34394L8.90234 24.1Z"
        fill="white"
      />
      <Path
        d="M12.1727 23.0059H9.93664L9.47083 24.1H10.9734C11.2431 23.6818 11.6626 23.3107 12.1727 23.0059Z"
        fill="white"
      />
      <Path
        d="M19.6105 25.595C19.6665 26.8284 18.2306 27.8867 16.4002 27.8867C14.5698 27.8867 13.207 26.8284 13.348 25.595C13.4808 24.4343 14.9111 23.543 16.55 23.543C18.1888 23.543 19.5579 24.4343 19.6105 25.595Z"
        fill="#03E484"
      />
      <Path
        d="M16.5945 23.709C16.5945 23.709 19.3099 24.0237 18.9679 25.4019C18.5999 26.8852 17.0922 26.8852 17.3239 25.929C17.5449 25.0172 16.7398 24.8188 16.3141 24.402C15.8977 23.9947 15.8863 23.7264 16.5945 23.709Z"
        fill="#04F2F5"
      />
      <Path
        d="M17.8997 19.4775L17.9045 21.83C17.9045 21.83 21.6134 22.5415 22.1926 24.726H30.0946L28.0715 19.5195L17.8997 19.4775Z"
        fill="#03E484"
      />
      <Path
        d="M26.4831 28.8757H23.0104L22.564 26.8086H25.7102L26.4831 28.8757Z"
        fill="white"
      />
      <Path
        d="M30.7972 28.8757H27.3249L26.4728 26.8086H29.619L30.7972 28.8757Z"
        fill="white"
      />
      <Path
        d="M27.6776 32.0702H23.701L23.1232 29.3955H26.6775L27.6776 32.0702Z"
        fill="white"
      />
      <Path
        d="M32.6182 32.0702H28.6413L27.5392 29.3955H31.0938L32.6182 32.0702Z"
        fill="white"
      />
      <Path
        d="M29.1265 36.4961L27.9521 32.8047H23.8594L24.2339 35.3118L29.1265 36.4961Z"
        fill="white"
      />
      <Path
        d="M20.6316 29.3955C20.1173 29.8888 19.4904 30.3422 18.7517 30.6067L18.8046 32.0702H22.759L22.2811 29.3955H20.6316Z"
        fill="white"
      />
      <Path
        d="M31.4025 34.9779C32.4983 35.2381 33.6067 35.5023 34.7276 35.7706L33.0369 32.8047H28.9448L29.671 34.5672L31.4025 34.9779Z"
        fill="white"
      />
      <Path
        d="M6.20581 26.7265C6.68995 26.7681 7.17721 26.8002 7.66861 26.8289C7.68798 26.6749 7.70803 26.5217 7.72221 26.3708C7.7608 25.9906 7.77581 25.6084 7.76717 25.2265C7.76717 25.1828 7.76267 25.1394 7.7606 25.0957H6.09203L5.59094 26.6691C5.79532 26.6883 6.00004 26.7084 6.20581 26.7265Z"
        fill="white"
      />
      <Path
        d="M5.77863 27.2471C5.65829 27.2355 5.53829 27.2232 5.41829 27.2109L4.97668 28.597L7.28121 29.1322C7.39429 28.5283 7.50426 27.9408 7.59245 27.3704C6.98312 27.3383 6.37482 27.3048 5.77863 27.2471Z"
        fill="white"
      />
      <Path
        d="M8.42078 26.8665C9.10999 26.9006 9.80197 26.9256 10.4915 26.9577C10.2176 25.8994 10.5507 25.0947 10.5507 25.0947H8.50101C8.50101 25.1251 8.50343 25.1552 8.50446 25.1852C8.52314 25.727 8.48614 26.2879 8.42078 26.8665Z"
        fill="white"
      />
      <Path
        d="M10.6915 27.5226C9.90996 27.4855 9.13014 27.4471 8.35205 27.4072C8.26663 28.0217 8.15805 28.6557 8.0498 29.3091L12.1889 30.2707C12.1889 30.2707 12.3272 30.013 12.3013 29.3948C11.4516 28.7799 10.9623 28.1262 10.6915 27.5226Z"
        fill="white"
      />
      <Path
        d="M2.52758 33.4277C2.74026 33.4321 14.1297 36.8074 14.1297 36.8074L13.8074 41.1952H0L2.52758 33.4277Z"
        fill="#03E484"
      />
      <Path
        d="M28.5585 7.08789H10.927V19.6436H28.5585V7.08789Z"
        fill="#94F3F7"
      />
      <Path
        d="M18.9621 32.7568L22.7996 32.8818L23.0026 35.25L18.9379 34.1022L18.9621 32.7568Z"
        fill="white"
      />
      <Path
        d="M7.85108 29.8125L12.0178 30.794L11.5129 32.6637L7.34619 31.417L7.85108 29.8125Z"
        fill="white"
      />
      <Path
        d="M7.12466 29.5794L6.4932 31.2621L5.13586 30.7948L5.70404 29.208L7.12466 29.5794Z"
        fill="white"
      />
      <Path
        d="M12.9014 29.8125L12.3018 32.8194L14.6374 33.3803L14.9531 30.3888L12.9014 29.8125Z"
        fill="white"
      />
      <Path
        d="M23.6733 9.59092L22.0283 9.57761L16.7407 3.15039L18.3934 3.16405L23.6733 9.59092Z"
        fill="#F13005"
      />
      <Path
        d="M22.0284 9.57725L20.3843 9.56394L15.0885 3.13672L16.7408 3.15003L22.0284 9.57725Z"
        fill="#F1E3E0"
      />
      <Path
        d="M20.3841 9.56553L18.7387 9.55222L13.4366 3.125L15.0883 3.13831L20.3841 9.56553Z"
        fill="#F13005"
      />
      <Path
        d="M25.3173 9.60425L23.6732 9.59094L18.3933 3.16406L20.0446 3.17738L25.3173 9.60425Z"
        fill="#F1E3E0"
      />
      <Path
        d="M28.606 9.63126L26.9623 9.61794L21.6969 3.19141L23.3482 3.20472L28.606 9.63126Z"
        fill="#F1E3E0"
      />
      <Path
        d="M33.3779 9.66895L31.8947 9.657L26.6517 3.23047L28.1401 3.24276L33.3779 9.66895Z"
        fill="#F13005"
      />
      <Path
        d="M31.8947 9.65762L30.251 9.64431L25.0005 3.21777L26.6518 3.23109L31.8947 9.65762Z"
        fill="#F1E3E0"
      />
      <Path
        d="M26.9623 9.61759L25.3172 9.60461L20.0446 3.17773L21.6969 3.19105L26.9623 9.61759Z"
        fill="#F13005"
      />
      <Path
        d="M30.251 9.64493L28.6059 9.63162L23.3481 3.20508L25.0005 3.21839L30.251 9.64493Z"
        fill="#F13005"
      />
      <Path
        d="M20.3841 9.56375V10.5422C20.3841 11.5789 18.7418 11.5663 18.7397 10.5292V9.55078L20.3841 9.56375Z"
        fill="#D62B04"
      />
      <Path
        d="M22.0285 9.57777V10.5562C22.0285 11.593 20.3862 11.5803 20.3859 10.5429V9.56445L22.0285 9.57777Z"
        fill="#F1C5BC"
      />
      <Path
        d="M23.6733 9.59144V10.5698C23.6733 11.6066 22.029 11.594 22.0293 10.5565V9.57812L23.6733 9.59144Z"
        fill="#D62B04"
      />
      <Path
        d="M25.3173 9.60511L25.3139 10.5835C25.3108 11.62 23.6692 11.6077 23.6709 10.5702V9.5918L25.3173 9.60511Z"
        fill="#F1C5BC"
      />
      <Path
        d="M26.9624 9.61683L26.9586 10.5952C26.9544 11.6317 25.3115 11.6194 25.3146 10.5819L25.3173 9.60352L26.9624 9.61683Z"
        fill="#D62B04"
      />
      <Path
        d="M28.606 9.6305L28.6011 10.6086C28.5959 11.6453 26.9544 11.6327 26.9585 10.5956L26.9623 9.61719L28.606 9.6305Z"
        fill="#F1C5BC"
      />
      <Path
        d="M30.251 9.64417L30.2451 10.6222C30.2385 11.659 28.5959 11.6464 28.6011 10.6089L28.6059 9.63086L30.251 9.64417Z"
        fill="#D62B04"
      />
      <Path
        d="M31.8952 9.6575L31.8879 10.6359C31.8803 11.6723 30.2387 11.6601 30.2453 10.6226L30.2511 9.64453L31.8952 9.6575Z"
        fill="#F1C5BC"
      />
      <Path
        d="M33.3783 9.67015L33.37 10.6486C33.3614 11.685 31.8802 11.6727 31.8878 10.6366L31.8951 9.6582L33.3783 9.67015Z"
        fill="#D62B04"
      />
      <Path
        d="M18.7388 9.55222L18.8678 9.56997L13.4298 9.52218L13.4367 3.125L18.7388 9.55222Z"
        fill="#F13005"
      />
      <Path
        d="M18.2108 35.5264C17.4428 34.7706 18.6538 32.9564 20.4407 31.2461C21.1765 30.5436 21.9624 29.894 22.7922 29.3023C22.8179 29.2898 22.8412 29.2731 22.8614 29.2531L22.898 29.2272C22.898 29.218 22.8966 29.209 22.8939 29.2002C22.8978 29.1875 22.899 29.1741 22.8973 29.1609L22.409 26.6347L26.202 26.6006C26.2296 26.6006 26.2568 26.5938 26.2812 26.581C26.3055 26.5682 26.3264 26.5497 26.3418 26.5271C26.3572 26.5044 26.3668 26.4784 26.3697 26.4513C26.3726 26.4242 26.3686 26.3968 26.3583 26.3715L25.6718 24.7069C25.659 24.6766 25.6373 24.6506 25.6096 24.6324C25.5818 24.6142 25.5492 24.6045 25.5159 24.6045H22.0577C21.8833 24.2046 21.6438 23.8356 21.3488 23.5121C20.8363 22.9409 19.8963 22.208 18.3402 21.9584C17.9943 21.9448 18.0096 22.2531 18.2862 22.2872C19.4527 22.4736 20.3957 22.956 21.0873 23.721C21.6061 24.2928 21.7807 24.8175 21.7824 24.8227C21.7934 24.8562 21.8149 24.8855 21.8438 24.9063C21.8727 24.9271 21.9075 24.9383 21.9432 24.9384H25.4035L25.9526 26.2698H22.1628C21.9208 26.2763 21.8516 26.4377 21.8561 26.6453L22.1182 28.9585C19.7141 30.2855 17.0191 32.0351 15.7898 33.109C14.1247 34.562 14.1433 37.107 16.1702 38.9781C20.7882 43.241 28.2679 46.1089 36.0927 48.0207C51.7897 51.8558 62.2109 52.5467 63.2518 52.6403C66.8013 52.928 71.4103 52.3962 70.9863 48.4392C70.5624 44.4822 77.2761 44.7482 77.9999 44.5713C70.0336 44.2521 24.8879 42.0946 18.2108 35.5264Z"
        fill="#808080"
      />
      <Path
        d="M77.9987 44.5651C75.7322 44.5108 71.3303 44.6976 70.8282 47.6717C70.7742 48.0213 70.8154 48.3736 70.8406 48.7221C70.8887 49.5097 70.6826 50.3212 70.1518 50.9217C68.5029 52.619 65.829 52.5839 63.6065 52.5053C56.9239 51.9967 50.2894 50.9302 43.7268 49.6002C36.4252 48.0711 29.0064 46.4629 22.3322 43.0535C19.9391 41.7931 17.5675 40.346 15.7001 38.3827C14.3711 36.899 14.2054 34.4745 15.79 33.1035C14.8625 33.861 14.3988 35.0979 14.5831 36.2709C14.988 38.9258 18.1149 40.6436 20.1915 42.043C24.9292 44.887 30.2514 46.6414 35.5949 48.0063C44.7916 50.2625 54.1328 52.052 63.5871 52.8153C66.1437 52.9351 69.9744 52.8785 71.008 50.0621C71.2988 49.297 71.0913 48.4989 71.1598 47.7161C71.5706 45.0588 76.0213 44.7973 78.0001 44.7771L77.9987 44.5651Z"
        fill="#636363"
      />
      <Path
        d="M22.6162 40.9004C24.5808 41.7617 26.8698 42.539 29.3541 43.2395C29.4883 43.0381 29.7224 42.6568 29.7923 42.567C27.3819 41.9716 25.1611 41.3039 23.2442 40.5576C23.0344 40.6723 22.8251 40.7866 22.6162 40.9004Z"
        fill="white"
      />
      <Path
        d="M16.5325 35.6699C16.4203 35.6973 16.3097 35.7305 16.2012 35.7696C16.3049 36.2383 16.5951 36.7651 16.9502 37.1928C17.0045 37.256 17.0605 37.3185 17.1183 37.3809L17.4786 37.1331C17.1027 36.7275 16.7306 36.2127 16.5325 35.6699Z"
        fill="white"
      />
      <Path
        d="M19.4351 31.2644C19.7263 31.0415 20.0309 30.8148 20.3553 30.5673C20.3179 30.5551 20.2806 30.5428 20.2426 30.5332C19.9237 30.7418 19.5893 30.9633 19.2552 31.1948C19.314 31.2167 19.3739 31.2409 19.4351 31.2644Z"
        fill="white"
      />
      <Path
        d="M18.8592 31.627C18.4501 31.9154 18.0462 32.2179 17.6761 32.5282C17.7571 32.5787 17.8425 32.6241 17.9279 32.6668C18.2836 32.3256 18.6584 32.0043 19.0504 31.7044C18.9854 31.6778 18.9225 31.6522 18.8592 31.627Z"
        fill="white"
      />
      <Path
        d="M17.4783 33.1874C17.3806 33.1354 17.2863 33.0774 17.1961 33.0137C16.438 33.7278 16.0611 34.37 16.1303 35.1736C16.2653 35.1724 16.4002 35.1633 16.5342 35.1463C16.5176 34.2764 17.0775 33.622 17.4783 33.1874Z"
        fill="white"
      />
      <Path
        d="M18.1395 38.3236C18.8702 38.9115 19.7452 39.469 20.7415 39.9964C20.9217 39.9013 21.1018 39.8057 21.2816 39.7096C20.2096 39.1952 19.2776 38.6472 18.5168 38.0635L18.1395 38.3236Z"
        fill="white"
      />
      <Path
        d="M33.4123 43.3828L32.5806 44.0833C35.6466 44.8282 38.909 45.4751 42.1728 46.0367C42.4796 45.8394 43.2144 45.2236 43.4396 45.0617C40.0385 44.5975 36.6218 44.043 33.4123 43.3828Z"
        fill="white"
      />
      <Path
        d="M65.2125 47.1982C62.023 46.9794 54.8598 46.3738 50.5329 45.916C49.9934 46.3079 49.4535 46.6994 48.9131 47.0904C52.983 47.6707 59.9678 48.4088 63.1583 48.7666C63.838 48.2374 64.5227 47.7146 65.2125 47.1982Z"
        fill="white"
      />
      <Path
        d="M18.3584 22.419C19.0444 22.419 19.6006 22.2432 19.6006 22.0264C19.6006 21.8096 19.0444 21.6338 18.3584 21.6338C17.6724 21.6338 17.1162 21.8096 17.1162 22.0264C17.1162 22.2432 17.6724 22.419 18.3584 22.419Z"
        fill="#222222"
      />
      <Path
        d="M18.8051 21.9926C18.8051 22.0783 18.5851 22.1479 18.3137 22.1479C18.0422 22.1479 17.8223 22.0796 17.8223 21.9926C17.8223 21.9055 18.0422 21.8369 18.3137 21.8369C18.5851 21.8369 18.8051 21.9066 18.8051 21.9926Z"
        fill="white"
      />
      <Path
        d="M18.3134 14.9219C17.6339 14.9221 16.9823 15.1886 16.5019 15.6629C16.0214 16.1372 15.7514 16.7804 15.7512 17.4512C15.7512 18.8485 18.3134 21.403 18.3134 21.403C18.3134 21.403 20.8762 18.8485 20.8762 17.4512C20.876 16.7803 20.606 16.137 20.1253 15.6627C19.6447 15.1883 18.993 14.9219 18.3134 14.9219ZM18.3134 18.873C18.0275 18.8729 17.7481 18.7891 17.5105 18.6322C17.2729 18.4753 17.0877 18.2524 16.9784 17.9917C16.8691 17.7309 16.8406 17.444 16.8964 17.1673C16.9523 16.8905 17.09 16.6363 17.2922 16.4368C17.4944 16.2373 17.7519 16.1015 18.0323 16.0464C18.3127 15.9914 18.6033 16.0197 18.8674 16.1278C19.1315 16.2358 19.3572 16.4187 19.516 16.6533C19.6748 16.888 19.7596 17.1639 19.7596 17.4461C19.7596 17.6335 19.7223 17.8192 19.6496 17.9924C19.5769 18.1655 19.4704 18.3229 19.3361 18.4554C19.2018 18.588 19.0423 18.6931 18.8668 18.7647C18.6913 18.8364 18.5033 18.8732 18.3134 18.873Z"
        fill="#FF3305"
      />
      <Path
        d="M37.6855 11.8661C37.6855 11.8435 37.6886 11.821 37.6886 11.7978C37.6886 11.6839 37.6659 11.5711 37.6218 11.4659C37.5776 11.3607 37.5129 11.2652 37.4314 11.1846C37.3498 11.1041 37.253 11.0402 37.1464 10.9967C37.0398 10.9531 36.9256 10.9307 36.8103 10.9307C36.6949 10.9307 36.5807 10.9531 36.4741 10.9967C36.3676 11.0402 36.2707 11.1041 36.1892 11.1846C36.1076 11.2652 36.0429 11.3607 35.9987 11.4659C35.9546 11.5711 35.9319 11.6839 35.9319 11.7978C35.9319 11.8206 35.9319 11.8432 35.9346 11.8661H37.6855Z"
        fill="white"
      />
      <Path
        d="M40.5712 11.8661C40.5712 11.8435 40.574 11.821 40.574 11.7978C40.574 11.6839 40.5513 11.5711 40.5072 11.4659C40.463 11.3607 40.3983 11.2652 40.3167 11.1846C40.2352 11.1041 40.1383 11.0402 40.0318 10.9967C39.9252 10.9531 39.811 10.9307 39.6956 10.9307C39.5803 10.9307 39.4661 10.9531 39.3595 10.9967C39.2529 11.0402 39.1561 11.1041 39.0745 11.1846C38.993 11.2652 38.9283 11.3607 38.8841 11.4659C38.84 11.5711 38.8173 11.6839 38.8173 11.7978C38.8173 11.8206 38.8173 11.8432 38.8204 11.8661H40.5712Z"
        fill="white"
      />
      <Path
        d="M41.3185 11.8635C41.3209 11.8408 41.3222 11.818 41.3223 11.7952C41.3117 11.6397 41.2417 11.4939 41.1264 11.3874C41.0111 11.2809 40.8591 11.2217 40.7012 11.2217C40.5433 11.2217 40.3912 11.2809 40.2759 11.3874C40.1606 11.4939 40.0906 11.6397 40.0801 11.7952C40.0801 11.818 40.0814 11.8408 40.0839 11.8635H41.3185Z"
        fill="white"
      />
      <Path
        d="M39.5615 11.8649C39.5846 11.6859 39.5689 11.5041 39.5154 11.3316C39.4618 11.1592 39.3717 10.9999 39.2509 10.8645C39.1301 10.7291 38.9816 10.6206 38.815 10.5463C38.6485 10.472 38.4678 10.4336 38.2851 10.4336C38.1023 10.4336 37.9217 10.472 37.7551 10.5463C37.5886 10.6206 37.44 10.7291 37.3192 10.8645C37.1985 10.9999 37.1083 11.1592 37.0548 11.3316C37.0012 11.5041 36.9855 11.6859 37.0087 11.8649H39.5615Z"
        fill="white"
      />
      <Path
        d="M47.377 8.69229C47.3801 8.65576 47.3818 8.61889 47.3818 8.58134C47.3818 8.20623 47.2309 7.84649 46.9622 7.58125C46.6935 7.316 46.3291 7.16699 45.9491 7.16699C45.5691 7.16699 45.2047 7.316 44.936 7.58125C44.6673 7.84649 44.5164 8.20623 44.5164 8.58134C44.5164 8.61889 44.5164 8.65576 44.5212 8.69229H47.377Z"
        fill="white"
      />
      <Path
        d="M52.0843 8.69229C52.0871 8.65576 52.0888 8.61889 52.0888 8.58134C52.0888 8.20623 51.9379 7.84649 51.6692 7.58125C51.4005 7.316 51.0361 7.16699 50.6561 7.16699C50.2761 7.16699 49.9117 7.316 49.643 7.58125C49.3743 7.84649 49.2234 8.20623 49.2234 8.58134C49.2234 8.61889 49.2255 8.65576 49.2282 8.69229H52.0843Z"
        fill="white"
      />
      <Path
        d="M53.303 8.69308C53.3192 8.55304 53.3053 8.4112 53.2621 8.27685C53.2189 8.1425 53.1475 8.01867 53.0524 7.91349C52.9574 7.80831 52.8409 7.72415 52.7106 7.66652C52.5803 7.60889 52.4391 7.5791 52.2963 7.5791C52.1535 7.5791 52.0124 7.60889 51.8821 7.66652C51.7518 7.72415 51.6353 7.80831 51.5402 7.91349C51.4452 8.01867 51.3737 8.1425 51.3305 8.27685C51.2873 8.4112 51.2734 8.55304 51.2897 8.69308H53.303Z"
        fill="white"
      />
      <Path
        d="M50.4366 8.69242C50.4478 8.60501 50.4535 8.51698 50.4535 8.42887C50.4571 8.15453 50.4055 7.88222 50.3016 7.62774C50.1977 7.37327 50.0437 7.14169 49.8484 6.94644C49.6531 6.7512 49.4205 6.59618 49.1641 6.49037C48.9077 6.38456 48.6325 6.33008 48.3546 6.33008C48.0767 6.33008 47.8015 6.38456 47.5451 6.49037C47.2887 6.59618 47.0561 6.7512 46.8608 6.94644C46.6656 7.14169 46.5115 7.37327 46.4076 7.62774C46.3038 7.88222 46.2521 8.15453 46.2557 8.42887C46.2556 8.51698 46.2611 8.605 46.2723 8.69242H50.4366Z"
        fill="white"
      />
      <Path
        d="M6.94733 37.225C6.94733 37.2028 6.94421 37.1806 6.94421 37.1567C6.94421 36.9312 7.03493 36.715 7.19642 36.5556C7.3579 36.3962 7.57692 36.3066 7.8053 36.3066C8.03367 36.3066 8.25269 36.3962 8.41418 36.5556C8.57566 36.715 8.66638 36.9312 8.66638 37.1567C8.66638 37.1789 8.66638 37.2011 8.66327 37.225H6.94733Z"
        fill="white"
      />
      <Path
        d="M4.11908 37.225C4.11735 37.2028 4.11597 37.1806 4.11597 37.1567C4.11597 36.9312 4.20669 36.715 4.36817 36.5556C4.52966 36.3962 4.74868 36.3066 4.97705 36.3066C5.20543 36.3066 5.42445 36.3962 5.58593 36.5556C5.74742 36.715 5.83814 36.9312 5.83814 37.1567C5.83814 37.1789 5.83814 37.2011 5.83502 37.225H4.11908Z"
        fill="white"
      />
      <Path
        d="M5.10915 37.2267C5.10248 37.1741 5.09913 37.1212 5.09912 37.0683C5.09912 36.9048 5.13174 36.7429 5.19512 36.5918C5.25851 36.4408 5.3514 36.3035 5.46852 36.1879C5.58563 36.0723 5.72466 35.9806 5.87768 35.918C6.03069 35.8554 6.19469 35.8232 6.36032 35.8232C6.52594 35.8232 6.68994 35.8554 6.84296 35.918C6.99597 35.9806 7.135 36.0723 7.25212 36.1879C7.36923 36.3035 7.46213 36.4408 7.52551 36.5918C7.58889 36.7429 7.62151 36.9048 7.62151 37.0683C7.6215 37.1212 7.61815 37.1741 7.61148 37.2267H5.10915Z"
        fill="white"
      />
      <Path
        style="mix-blend-mode:screen"
        opacity="0.5"
        d="M53.3254 19.9867C46.4118 19.7173 39.1445 18.9205 31.6886 17.8428L31.3912 18.3548C38.864 20.523 44.8874 21.8185 50.4897 22.321C50.8625 21.8301 52.5141 20.3151 53.3254 19.9867Z"
        fill="url(#paint0_linear_1_19167)"
      />
      <Path
        style="mix-blend-mode:screen"
        opacity="0.5"
        d="M56.9993 14.9789C50.0857 14.7092 45.6516 14.5792 38.8093 13.8145L38.6284 14.1261C46.2509 15.4418 50.0995 15.7552 55.7049 16.2581C55.7986 15.8709 56.3875 15.1943 56.9993 14.9789Z"
        fill="url(#paint1_linear_1_19167)"
      />
      <Path
        style="mix-blend-mode:screen"
        opacity="0.5"
        d="M37.9837 34.8144C31.7738 34.3829 25.8455 33.3382 21.2496 30.1855L21.0684 30.4972C25.6888 34.557 30.245 37.0518 36.4652 37.9158C36.5599 37.5287 37.3598 35.6886 37.9837 34.8144Z"
        fill="url(#paint2_linear_1_19167)"
      />
      <G style="mix-blend-mode:soft-light" opacity="0.6">
        <Path
          d="M38.846 42.2566L63.5588 44.7466C66.6324 45.2997 64.1263 48.0949 58.227 47.7027C58.227 47.7027 43.7999 45.9766 36.3001 44.8333C33.5899 44.4199 34.2864 41.6865 38.846 42.2566Z"
          fill="#222222"
        />
      </G>
      <Path
        d="M43.775 31.0287L35.7559 30.3292L35.8925 22.0742L43.9116 22.7737L43.775 31.0287Z"
        fill="#DE7F04"
      />
      <Path
        d="M35.5954 21.7656L35.5667 23.4999L44.1374 24.2475L44.1675 22.4286L35.5954 21.7656Z"
        fill="#DE7F04"
      />
      <Path
        d="M39.7184 30.7407L33.075 30.1589L33.2122 21.9043L39.8557 22.4857L39.7184 30.7407Z"
        fill="#FFA305"
      />
      <Path
        d="M32.9674 21.5625L32.938 23.3346L40.0383 23.9563L40.0677 22.1114L32.9674 21.5625Z"
        fill="#FFA305"
      />
      <Path
        d="M33.1935 23.3162L33.1863 23.3965L41.5068 24.1252L41.514 24.045L33.1935 23.3162Z"
        fill="#DE7F04"
      />
      <Path
        d="M34.5129 30.2859L34.0153 30.2425L34.1588 21.6533L34.6561 21.697L34.5129 30.2859Z"
        fill="white"
      />
      <Path
        d="M38.677 30.6541L38.1797 30.6108L38.3225 21.9844L38.8198 22.0277L38.677 30.6541Z"
        fill="white"
      />
      <Path
        d="M46.0579 41.3002C46.6791 39.4175 45.7349 37.4258 43.949 36.8516C42.1632 36.2774 40.2119 37.3382 39.5908 39.2209C38.9696 41.1036 39.9138 43.0954 41.6997 43.6695C43.4855 44.2437 45.4368 43.1829 46.0579 41.3002Z"
        fill="#222222"
      />
      <Path
        d="M47.0936 40.5215C46.9003 42.5807 45.2262 44.1494 43.0348 44.0138C40.8433 43.8783 39.2235 42.099 39.4172 40.0398C39.6109 37.9806 41.5443 36.4211 43.7358 36.556C45.9272 36.6908 47.2873 38.4619 47.0936 40.5215Z"
        fill="#222222"
      />
      <Path
        d="M45.1106 40.9962C45.5498 39.6649 44.8823 38.2566 43.6196 37.8506C42.3569 37.4447 40.9773 38.1948 40.5381 39.526C40.0989 40.8573 40.7664 42.2656 42.0291 42.6716C43.2917 43.0776 44.6714 42.3275 45.1106 40.9962Z"
        fill="#CCCCCC"
      />
      <Path
        d="M43.7957 40.591C44.0004 39.9704 43.6891 39.3138 43.1004 39.1245C42.5116 38.9352 41.8684 39.2849 41.6636 39.9055C41.4588 40.5262 41.7701 41.1827 42.3589 41.372C42.9476 41.5613 43.5909 41.2117 43.7957 40.591Z"
        fill="#737373"
      />
      <Path
        d="M52.5544 39.6087C51.9381 39.6633 45.1885 39.5719 52.5602 32.1519C44.2022 31.4026 40.1755 29.8373 36.7758 39.4438L51.8849 40.6769C52.6066 40.7216 52.7546 39.8678 52.5544 39.6087Z"
        fill="#E82728"
      />
      <Path
        d="M53.7716 32.2231L45.5273 31.5595C44.6379 31.4868 44.7983 29.6136 45.6878 29.6877L53.9324 30.3527C54.9958 30.438 54.8353 32.3105 53.7716 32.2231Z"
        fill="#222222"
      />
      <Path
        d="M43.8968 31.6988L36.8266 31.1481C36.7797 31.1446 36.734 31.1319 36.6921 31.1108C36.6502 31.0897 36.613 31.0606 36.5825 31.0252C36.5521 30.9898 36.529 30.9488 36.5147 30.9046C36.5004 30.8604 36.4951 30.8138 36.4991 30.7675C36.5075 30.6736 36.553 30.5869 36.6259 30.526C36.6988 30.4651 36.793 30.4351 36.8882 30.4425L43.9584 30.9935C44.0053 30.997 44.051 31.0097 44.0929 31.0308C44.1349 31.0519 44.1721 31.081 44.2026 31.1164C44.233 31.1518 44.2561 31.1928 44.2704 31.237C44.2847 31.2813 44.2899 31.3279 44.2859 31.3741C44.2774 31.4679 44.2318 31.5546 44.159 31.6154C44.0861 31.6762 43.9919 31.7062 43.8968 31.6988Z"
        fill="#222222"
      />
      <Path
        d="M37.666 30.7292L37.3604 30.9619L39.9445 34.2697L40.2501 34.037L37.666 30.7292Z"
        fill="#222222"
      />
      <Path
        d="M51.0773 32.0928C51.0773 32.0928 44.0174 39.3854 51.0811 39.734C52.4816 39.7708 52.556 39.608 52.556 39.608C50.5309 39.2666 48.6137 38.5074 50.2546 35.921C51.6115 33.7813 53.9009 32.2047 53.9009 32.2047L51.0773 32.0928Z"
        fill="#B81F20"
      />
      <Path
        d="M47.1414 40.2778C47.2532 40.0467 47.3503 39.809 47.4322 39.566C48.3341 36.8868 46.9588 34.8501 44.4817 34.3404C38.8985 33.1917 37.2807 39.2328 37.2347 39.469L47.1414 40.2778Z"
        fill="#B81F20"
      />
      <Path
        d="M45.8443 40.1724C45.9558 39.9413 46.0529 39.7037 46.1351 39.461C47.0367 36.7815 45.7157 34.4426 43.1846 34.2354C40.6536 34.0282 37.8705 36.0335 36.9679 38.7127C36.8884 38.9483 36.8246 39.1888 36.777 39.4326L45.8443 40.1724Z"
        fill="#E82728"
      />
      <Path
        d="M43.8384 36.7301L40.559 36.5321C40.544 36.5313 40.5292 36.5276 40.5157 36.521C40.5021 36.5145 40.49 36.5053 40.4801 36.4941C40.4703 36.4828 40.4628 36.4697 40.4582 36.4556C40.4535 36.4414 40.4519 36.4264 40.4532 36.4116V36.4007C40.4564 36.3702 40.4713 36.3421 40.495 36.3222C40.5186 36.3024 40.5491 36.2923 40.5801 36.2942L43.8592 36.4918C43.8742 36.4926 43.889 36.4964 43.9025 36.503C43.9161 36.5095 43.9282 36.5187 43.9381 36.5299C43.948 36.5412 43.9555 36.5542 43.9602 36.5684C43.9649 36.5825 43.9666 36.5975 43.9653 36.6123V36.6236C43.962 36.654 43.947 36.682 43.9234 36.7018C43.8998 36.7216 43.8694 36.7318 43.8384 36.7301Z"
        fill="#222222"
      />
      <Path
        d="M43.788 37.2708L40.5086 37.0731C40.4936 37.0723 40.4788 37.0686 40.4652 37.062C40.4517 37.0555 40.4396 37.0463 40.4297 37.0351C40.4198 37.0238 40.4124 37.0107 40.4077 36.9966C40.4031 36.9824 40.4014 36.9674 40.4028 36.9526V36.9413C40.4061 36.9109 40.4212 36.883 40.4448 36.8632C40.4684 36.8434 40.4988 36.8334 40.5297 36.8352L43.8091 37.0328C43.8242 37.0336 43.8389 37.0373 43.8525 37.0439C43.866 37.0504 43.8781 37.0596 43.888 37.0708C43.8979 37.0821 43.9054 37.0952 43.91 37.1094C43.9146 37.1235 43.9163 37.1385 43.9149 37.1533V37.1642C43.9116 37.1947 43.8966 37.2227 43.873 37.2425C43.8494 37.2623 43.819 37.2724 43.788 37.2708Z"
        fill="#222222"
      />
      <Path
        d="M43.7382 37.8118L40.4588 37.6141C40.4437 37.6133 40.4289 37.6096 40.4153 37.6031C40.4018 37.5965 40.3897 37.5874 40.3798 37.5761C40.3698 37.5649 40.3623 37.5518 40.3577 37.5376C40.353 37.5234 40.3513 37.5085 40.3526 37.4936V37.4827C40.3559 37.4522 40.371 37.4241 40.3947 37.4043C40.4184 37.3845 40.4489 37.3744 40.4799 37.3762L43.7589 37.5738C43.774 37.5746 43.7887 37.5784 43.8023 37.585C43.8158 37.5915 43.8279 37.6007 43.8378 37.6119C43.8477 37.6232 43.8552 37.6362 43.8599 37.6504C43.8646 37.6646 43.8663 37.6795 43.8651 37.6943V37.7056C43.8617 37.736 43.8467 37.764 43.8231 37.7837C43.7995 37.8035 43.7691 37.8135 43.7382 37.8118Z"
        fill="#222222"
      />
      <Path
        d="M43.6883 38.3518L40.4089 38.1542C40.3938 38.1533 40.3791 38.1496 40.3656 38.143C40.352 38.1365 40.34 38.1273 40.3301 38.116C40.3202 38.1048 40.3127 38.0917 40.3081 38.0776C40.3034 38.0634 40.3017 38.0485 40.303 38.0336V38.0224C40.3064 37.992 40.3214 37.964 40.345 37.9443C40.3686 37.9245 40.399 37.9145 40.43 37.9162L43.7114 38.1128C43.7265 38.1136 43.7412 38.1174 43.7548 38.1239C43.7684 38.1304 43.7804 38.1396 43.7903 38.1509C43.8002 38.1621 43.8077 38.1752 43.8123 38.1894C43.8169 38.2036 43.8186 38.2185 43.8172 38.2334V38.2443C43.8142 38.2753 43.799 38.3038 43.7749 38.3239C43.7508 38.344 43.7197 38.354 43.6883 38.3518Z"
        fill="#222222"
      />
      <Path
        d="M55.725 21.4226C55.725 21.4226 54.7366 24.8771 55.1329 26.2091C55.9449 27.5491 62.0859 27.421 62.0859 27.421L62.5355 26.4389L58.4822 25.229L58.8913 22.8052C59.3007 20.621 56.8019 19.8717 55.725 21.4226Z"
        fill="#E35C12"
      />
      <Path
        d="M51.6476 39.5404L54.1492 39.7496C54.8097 38.8825 59.2936 32.9326 59.4108 31.552C59.5094 30.3947 59.0529 29.2647 56.1256 28.0521C54.1638 27.238 51.9018 27.6425 51.9018 27.6425C51.9018 27.6425 50.2477 29.36 51.6224 30.3783C52.997 31.3967 55.6086 31.9975 55.6086 31.9975L51.6476 39.5404Z"
        fill="#024545"
      />
      <Path
        d="M51.637 39.5592L56.7015 39.947C56.7015 39.947 58.2386 39.3326 57.1714 38.0196C56.3366 37.2474 54.6559 37.6352 54.0279 38.4866L52.2881 38.3787L51.637 39.5592Z"
        fill="#222222"
      />
      <Path
        d="M48.8596 39.3677L51.3616 39.5766C52.0218 38.7098 56.506 32.7599 56.6232 31.379C56.7218 30.222 56.2653 29.0917 53.338 27.8791C51.3761 27.0649 49.9835 27.2708 49.3002 27.4282C48.6169 27.5855 47.4598 29.1853 48.8344 30.2039C50.209 31.2226 52.821 31.8231 52.821 31.8231L48.8596 39.3677Z"
        fill="#027273"
      />
      <Path
        d="M48.8489 39.3875L53.9127 39.7753C53.9127 39.7753 55.4499 39.1608 54.3827 37.8479C53.5479 37.0753 51.8672 37.4635 51.2389 38.3149L49.4991 38.2067C48.6487 38.6153 48.8202 39.0011 48.8489 39.3875Z"
        fill="#222222"
      />
      <Path
        d="M55.6615 28.0675C56.9064 27.5602 57.7309 24.9268 58.5352 23.3028C59.9732 20.4011 55.426 18.3275 52.9942 20.8872C50.7523 23.1192 48.389 25.2552 48.6833 27.8279C50.8007 28.8438 54.7136 28.5455 55.6615 28.0675Z"
        fill="#FF8812"
      />
      <Path
        d="M54.7538 28.3664L54.714 28.2961C55.1393 28.0612 55.3019 27.5509 55.4879 26.9599C55.6608 26.4093 55.8604 25.7849 56.322 25.2943C57.5172 23.6215 57.8623 22.4236 57.9412 21.7122C58.0266 20.9434 57.8277 20.5641 57.826 20.5604L57.8976 20.5225C57.9062 20.5382 58.1089 20.9212 58.0231 21.7115C57.945 22.4339 57.5974 23.6506 56.3871 25.3428L56.3836 25.3469C55.934 25.8248 55.738 26.4393 55.5657 26.9855C55.3735 27.5915 55.2075 28.1158 54.7538 28.3664Z"
        fill="#386B45"
      />
      <Path
        d="M53.0448 21.1532C53.0448 21.1532 49.6426 24.4042 50.6915 26.2118C51.5356 27.6658 56.7734 27.9737 57.1258 27.5804L57.5753 26.5983C57.1949 25.7107 55.2525 25.3529 53.7143 25.005L55.4662 23.4241C56.9909 21.963 54.9596 19.4818 53.0448 21.1532Z"
        fill="#FFA517"
      />
      <Path
        d="M58.0677 21.4761C58.0677 21.4761 58.3564 21.6468 58.3163 22.0722C58.9122 21.6007 58.3163 20.0491 56.8023 19.5067C55.3655 18.9922 58.0677 21.4761 58.0677 21.4761Z"
        fill="#FFA517"
      />
      <Path
        d="M56.3756 19.811C55.9357 20.2759 58.0673 21.4749 58.0673 21.4749L59.5651 19.4781L57.8246 18.3516L56.3756 19.811Z"
        fill="#FFA794"
      />
      <Path
        d="M57.2635 17.7599C57.2635 17.7599 57.73 20.7886 60.2541 20.5322C61.3839 20.4175 61.8794 18.7632 61.8722 17.796C61.8559 15.6696 59.9868 14.6212 58.858 15.093C56.9865 15.8744 57.2548 17.4738 57.2635 17.7599Z"
        fill="#FFA794"
      />
      <Path
        d="M57.6257 18.9121C57.6257 18.9121 58.113 20.2831 59.3451 20.5371C59.8421 20.6054 59.971 20.5491 59.971 20.5491C59.7656 20.5426 58.4014 20.1302 58.1856 18.6291C58.1088 18.34 57.5272 18.5578 57.6257 18.9121Z"
        fill="#222222"
      />
      <Path
        d="M58.3632 18.7887C58.6398 18.3281 58.7809 17.7096 58.9414 17.0613C59.7644 17.1692 60.8524 17.2839 62.0219 17.2705C62.3542 17.2705 62.5292 14.9054 59.8498 14.5395C58.7685 14.3917 57.4205 14.7528 56.8492 15.8026C56.234 16.9322 56.3885 18.2107 56.9356 18.7818C57.2846 19.1444 57.9883 19.2222 58.3632 18.7887Z"
        fill="#E82728"
      />
      <Path
        d="M61.273 17.2428L61.1229 17.2729C61.3775 16.317 60.7737 15.5807 60.3777 15.2645C59.6985 14.7221 58.7323 14.4596 58.2682 14.6914L58.2087 14.5746C58.723 14.3182 59.7338 14.5821 60.4614 15.1631C60.8816 15.4991 61.5462 16.2156 61.273 17.2428Z"
        fill="white"
      />
      <Path
        d="M61.5407 17.3325L61.4138 17.2956C61.6179 16.6111 61.4453 15.9331 60.9297 15.3866C60.3397 14.7622 59.4299 14.455 58.667 14.6212L58.6383 14.4939C59.4458 14.3177 60.4054 14.6407 61.0265 15.2975C61.5753 15.8792 61.7583 16.6019 61.5407 17.3325Z"
        fill="white"
      />
      <Path
        d="M60.6493 18.6979C60.5765 18.6989 60.5038 18.6928 60.4322 18.6798C60.4207 18.6775 60.4106 18.6709 60.4041 18.6613C60.3976 18.6517 60.3953 18.6399 60.3976 18.6286C60.3999 18.6173 60.4066 18.6073 60.4164 18.6009C60.4261 18.5945 60.438 18.5922 60.4495 18.5944C60.4529 18.5944 60.787 18.6593 60.9568 18.5262C60.9638 18.5207 60.9694 18.5137 60.9733 18.5057C60.9771 18.4977 60.979 18.4889 60.9789 18.4801C60.9875 18.3306 60.7023 18.0202 60.593 17.9134C60.5888 17.9094 60.5855 17.9046 60.5833 17.8994C60.581 17.8941 60.5798 17.8885 60.5797 17.8828C60.5797 17.8771 60.5807 17.8714 60.5829 17.8661C60.585 17.8608 60.5882 17.856 60.5923 17.8519C60.5963 17.8479 60.6011 17.8446 60.6065 17.8424C60.6118 17.8401 60.6175 17.8389 60.6233 17.8389C60.629 17.8388 60.6348 17.8399 60.6401 17.842C60.6455 17.8441 60.6504 17.8473 60.6545 17.8513C60.6981 17.8936 61.0788 18.2695 61.0671 18.4849C61.0665 18.5061 61.0611 18.527 61.0515 18.546C61.0418 18.565 61.028 18.5816 61.0111 18.5948C60.9094 18.6747 60.7676 18.6962 60.6493 18.6979Z"
        fill="#B3523D"
      />
      <Path
        d="M59.6103 17.7328C59.5993 17.8516 59.5173 17.9438 59.4278 17.9376C59.3382 17.9315 59.2742 17.8311 59.2856 17.712C59.297 17.5928 59.3786 17.501 59.4682 17.5071C59.5578 17.5133 59.6214 17.6119 59.6103 17.7328Z"
        fill="#222222"
      />
      <Path
        d="M61.5288 17.8786C61.5191 17.9811 61.4493 18.0589 61.3725 18.0541C61.2957 18.0493 61.2414 17.9633 61.2511 17.8616C61.2608 17.7598 61.3307 17.681 61.4074 17.6858C61.4842 17.6905 61.5381 17.7769 61.5288 17.8786Z"
        fill="#222222"
      />
      <Path
        d="M59.4191 18.8711C59.4191 18.8711 59.9108 19.4658 61.0268 19.3914C61.0268 19.3914 60.3943 20.2414 59.6435 19.8891C58.8927 19.5368 59.4191 18.8711 59.4191 18.8711Z"
        fill="#B33A20"
      />
      <Path
        d="M58.941 17.0615C60.1777 17.1882 61.369 17.3005 62.0835 17.2558C62.0835 17.2558 62.9034 17.504 62.6866 17.6695C62.4698 17.8351 58.941 17.0615 58.941 17.0615Z"
        fill="#222222"
      />
      <Path
        d="M56.8022 19.5064C56.8022 19.5064 56.3426 19.2947 56.1219 19.7481C56.1814 20.8839 57.0557 21.9589 57.508 22.0657C57.5813 21.8821 57.738 21.6561 58.0675 21.4758C58.0675 21.4758 56.8053 20.4428 56.8022 19.5064Z"
        fill="#FFA517"
      />
      <Path
        d="M65.2946 43.114C65.8778 41.3463 64.9913 39.4764 63.3146 38.9373C61.6379 38.3982 59.8059 39.3941 59.2227 41.1617C58.6395 42.9294 59.526 44.7993 61.2027 45.3384C62.8794 45.8775 64.7114 44.8816 65.2946 43.114Z"
        fill="#222222"
      />
      <Path
        d="M66.2659 42.3809C66.0843 44.3145 64.5126 45.7873 62.455 45.6582C60.3974 45.5292 58.8768 43.8605 59.0587 41.9269C59.2406 39.9933 61.0558 38.5291 63.1134 38.6561C65.171 38.7831 66.4478 40.448 66.2659 42.3809Z"
        fill="#222222"
      />
      <Path
        d="M64.4052 42.8281C64.8175 41.5782 64.1908 40.256 63.0053 39.8748C61.8198 39.4937 60.5245 40.1979 60.1121 41.4478C59.6998 42.6977 60.3265 44.0199 61.512 44.4011C62.6975 44.7822 63.9928 44.078 64.4052 42.8281Z"
        fill="#CCCCCC"
      />
      <Path
        d="M63.1707 42.4477C63.363 41.8649 63.0707 41.2484 62.5179 41.0706C61.9651 40.8929 61.3611 41.2213 61.1688 41.8041C60.9766 42.3869 61.2688 43.0035 61.8216 43.1812C62.3744 43.3589 62.9784 43.0305 63.1707 42.4477Z"
        fill="#737373"
      />
      <Path
        d="M63.9038 39.5498C63.2575 40.3571 62.3822 40.958 61.3686 41.2089C61.307 41.2239 61.2451 41.2382 61.1829 41.2505C61.083 41.271 60.9827 41.2877 60.8813 41.3004C60.6537 41.3301 60.4241 41.3421 60.1945 41.3362C60.1074 41.3345 60.0216 41.3297 59.9335 41.3229L59.8677 41.3174L55.8646 40.9907L52.0454 40.7296C50.2495 40.6186 50.4615 39.9444 52.1778 39.7078C57.5248 39.7293 59.9179 34.1204 58.5657 31.1732C58.1048 30.0952 59.3265 29.268 60.5002 29.0908C60.6503 29.0683 60.8018 29.0569 60.9536 29.0567C61.053 29.0562 61.1524 29.062 61.251 29.0741C61.2814 29.0782 61.3108 29.0819 61.3406 29.0871C61.4876 29.1057 61.6326 29.1373 61.7739 29.1813C62.1944 29.313 62.562 29.5595 62.8051 29.9443L64.6155 33.9832C65.4952 35.9451 65.0761 38.0863 63.9038 39.5498Z"
        fill="#E82728"
      />
      <Path
        d="M63.5627 37.2098C63.5474 37.3088 63.5295 37.4064 63.5087 37.5024L64.0053 37.5236C64.0171 37.4601 64.0281 37.3976 64.0375 37.3358C64.2595 35.8733 63.8511 34.6819 63.8338 34.6321L61.7741 29.1805C61.5852 29.1326 61.392 29.1032 61.1973 29.0928L63.3897 34.8335C63.4112 34.897 63.7546 35.9464 63.5627 37.2098Z"
        fill="white"
      />
      <Path
        d="M63.6303 25.5493C63.5765 25.5427 63.5222 25.5412 63.4681 25.5449C63.3743 25.5515 63.2819 25.5715 63.1939 25.6043C62.5258 25.8494 61.9673 26.8026 61.8891 27.9083C61.8359 28.6624 62.0181 29.3158 62.3425 29.7057C62.438 29.8237 62.557 29.9211 62.6921 29.9921L61.822 29.6931L61.748 29.6675C61.1484 29.4346 60.7524 28.6122 60.8185 27.6089C60.8956 26.4373 61.5741 25.4459 62.3556 25.335C62.4971 25.3394 62.6437 25.351 62.7945 25.3691C63.0776 25.4065 63.3571 25.4668 63.6303 25.5493Z"
        fill="#FF6162"
      />
      <Path
        d="M61.749 29.6667L59.1878 28.7869C59.1878 28.7869 58.2925 28.3855 58.8036 27.1824C58.8036 27.1824 59.9569 25.2591 62.3566 25.3352C61.575 25.4462 60.8965 26.4375 60.8194 27.6092C60.7534 28.6115 61.1493 29.4339 61.749 29.6667Z"
        fill="#E82728"
      />
      <Path
        d="M63.6305 25.5503C63.609 25.6558 63.5741 25.832 63.5312 26.0556C63.3621 26.934 63.0616 28.5391 62.8984 29.4148L62.7843 30.0245L62.6923 29.9931C62.5572 29.9221 62.4382 29.8247 62.3427 29.7067C62.0183 29.3168 61.836 28.6634 61.8893 27.9093C61.9675 26.8036 62.5259 25.8504 63.1941 25.6053C63.2821 25.5725 63.3745 25.5524 63.4683 25.5459C63.5224 25.5422 63.5767 25.5437 63.6305 25.5503Z"
        fill="#E82728"
      />
      <Path
        d="M64.727 27.7213C64.6381 28.9752 63.9316 30.0335 63.148 30.085C62.9906 30.0955 62.8333 30.063 62.6933 29.9912C62.5582 29.9202 62.4392 29.8227 62.3436 29.7047C62.0193 29.3149 61.837 28.6615 61.8903 27.9074C61.9684 26.8016 62.5269 25.8485 63.195 25.6034C63.283 25.5705 63.3754 25.5505 63.4693 25.544C63.5234 25.5403 63.5777 25.5418 63.6315 25.5484C64.3286 25.6313 64.8093 26.5555 64.727 27.7213Z"
        fill="#FF6162"
      />
      <Path
        d="M64.575 27.7354C64.5017 28.7756 63.9148 29.6536 63.265 29.6963C63.1344 29.705 63.0039 29.6781 62.8878 29.6184C62.7755 29.5593 62.6769 29.478 62.598 29.3795C62.3286 29.0562 62.1771 28.5141 62.2214 27.8883C62.2864 26.9707 62.7498 26.1814 63.3041 25.9766C63.3771 25.9492 63.4538 25.9327 63.5317 25.9274C63.5765 25.9244 63.6216 25.9256 63.6662 25.9308C64.2444 26.0015 64.6435 26.7682 64.575 27.7354Z"
        fill="white"
      />
      <Path
        d="M59.7742 28.2006L56.7272 28.2689L56.7344 26.9648L59.7804 27.0673C60.3717 27.0536 60.3368 28.1884 59.7742 28.2006Z"
        fill="#222222"
      />
      <Path
        d="M57.1478 27.6222C57.1568 27.262 56.9751 26.9655 56.742 26.9598C56.5089 26.9541 56.3126 27.2415 56.3036 27.6017C56.2946 27.9619 56.4763 28.2585 56.7095 28.2642C56.9426 28.2698 57.1389 27.9824 57.1478 27.6222Z"
        fill="#222222"
      />
      <Path
        d="M64.4295 38.5546C64.3007 38.9079 64.1238 39.2424 63.9039 39.5487C63.2572 40.3558 62.3823 40.9569 61.3687 41.2079C61.2082 41.2475 61.0455 41.2781 60.8814 41.2993C60.5672 41.3399 60.2494 41.3475 59.9335 41.3219L59.8678 41.3164L55.865 40.9897C55.9044 40.9873 58.3753 41.1945 60.1988 38.3815C61.7684 36.0325 65.0828 36.6791 64.4295 38.5546Z"
        fill="#B81F20"
      />
      <Path
        d="M67.4814 41.8126C67.5069 41.7929 67.5244 41.7648 67.5305 41.7334C67.8698 39.3779 65.0407 36.8602 62.8409 37.1077C60.9182 37.6078 59.7227 39.2895 59.4644 41.2849L67.4814 41.8126Z"
        fill="#E82728"
      />
      <Path
        d="M57.0448 26.8952C57.0448 26.8952 57.4857 26.2565 58.4972 26.6071C59.5088 26.9577 59.1654 28.0774 58.8928 28.2191C58.6203 28.3608 57.678 28.4898 57.8156 28.2426C57.9533 27.9955 58.0978 27.5828 57.8665 27.2421C57.7084 27.0092 57.0365 26.9727 57.0365 26.9727L57.0448 26.8952Z"
        fill="#FFA794"
      />
      <Path
        d="M44.2645 31.3862L43.8599 31.3405L44.1019 29.2349L42.3922 29.1294L42.1533 31.191L41.7487 31.1452L42.0094 28.8921C42.0154 28.8409 42.0411 28.794 42.0811 28.7609C42.1211 28.7278 42.1724 28.7111 42.2245 28.7142L44.3412 28.845C44.3688 28.8467 44.3958 28.854 44.4204 28.8663C44.4451 28.8786 44.467 28.8957 44.4847 28.9166C44.5025 28.9375 44.5157 28.9618 44.5237 28.9879C44.5317 29.014 44.5342 29.0415 44.5311 29.0686L44.2645 31.3862Z"
        fill="#222222"
      />
      <G style="mix-blend-mode:soft-light" opacity="0.8">
        <Path
          d="M39.4729 39.665L47.1414 40.2782L46.8381 41.6109L39.4044 40.5171L39.4729 39.665Z"
          fill="#222222"
        />
      </G>
      <G style="mix-blend-mode:soft-light" opacity="0.8">
        <Path
          d="M59.1806 41.2607L66.2796 41.7387C66.2982 42.2316 66.2554 42.6881 66.1305 43.0967L59.0413 42.12C59.0624 41.808 59.1025 41.5161 59.1806 41.2607Z"
          fill="#222222"
        />
      </G>
      <Path
        d="M40.3905 19.4604C41.2337 18.628 41.2337 17.2783 40.3905 16.4459C39.5472 15.6134 38.18 15.6134 37.3368 16.4459C36.4935 17.2783 36.4935 18.628 37.3368 19.4604C38.18 20.2928 39.5472 20.2928 40.3905 19.4604Z"
        fill="#56A66B"
      />
      <Path
        d="M38.7473 18.9541L37.741 17.4021L37.9101 17.2256L38.7438 18.0043L41.2645 15.7881L41.4284 15.9939L38.7473 18.9541Z"
        fill="white"
      />
      <Path
        style="mix-blend-mode:screen"
        opacity="0.5"
        d="M63.5317 25.9282L74.686 25.4277L73.5421 32.4015L63.115 29.6991L63.5317 25.9282Z"
        fill="url(#paint3_linear_1_19167)"
      />
      <Path
        d="M30.4346 13.2793H22.947C22.6221 13.2793 22.3588 13.5393 22.3588 13.86V18.1751C22.3588 18.4958 22.6221 18.7558 22.947 18.7558H30.4346C30.7595 18.7558 31.0229 18.4958 31.0229 18.1751V13.86C31.0229 13.5393 30.7595 13.2793 30.4346 13.2793Z"
        fill="white"
      />
      <Path
        d="M24.0113 17.2529L24.0946 17.5059H24.364L24.1462 17.6622L24.2292 17.9152L24.0113 17.7589L23.7934 17.9152L23.8764 17.6622L23.6586 17.5059H23.928L24.0113 17.2529Z"
        fill="#FDF280"
      />
      <Path
        d="M25.3359 17.2529L25.4192 17.5059H25.6886L25.4708 17.6622L25.5541 17.9152L25.3359 17.7589L25.118 17.9152L25.2014 17.6622L24.9832 17.5059H25.2529L25.3359 17.2529Z"
        fill="#FDF280"
      />
      <Path
        d="M26.6605 17.2529L26.7438 17.5059H27.0132L26.795 17.6622L26.8783 17.9152L26.6605 17.7589L26.4426 17.9152L26.5256 17.6622L26.3077 17.5059H26.5771L26.6605 17.2529Z"
        fill="#FDF280"
      />
      <Path
        d="M27.9854 17.2529L28.0688 17.5059H28.3382L28.1203 17.6622L28.2036 17.9152L27.9854 17.7589L27.7676 17.9152L27.8509 17.6622L27.6327 17.5059H27.9021L27.9854 17.2529Z"
        fill="#FDF280"
      />
      <Path
        d="M29.3103 17.2529L29.3932 17.5059H29.663L29.4448 17.6622L29.5281 17.9152L29.3103 17.7589L29.092 17.9152L29.1754 17.6622L28.9575 17.5059H29.2269L29.3103 17.2529Z"
        fill="#FDF280"
      />
      <Path
        d="M29.511 14.6379H27.6436C27.6037 14.6377 27.5655 14.6221 27.5373 14.5943C27.509 14.5666 27.4929 14.529 27.4924 14.4897C27.4925 14.45 27.5085 14.4119 27.537 14.3838C27.5654 14.3558 27.604 14.3399 27.6442 14.3398H29.5117C29.5519 14.3399 29.5905 14.3558 29.6189 14.3838C29.6474 14.4119 29.6634 14.45 29.6635 14.4897C29.663 14.5293 29.6467 14.5671 29.6182 14.5948C29.5896 14.6226 29.5511 14.6381 29.511 14.6379Z"
        fill="#94F3F7"
      />
      <Path
        d="M29.5111 15.2939H27.0904C27.0704 15.2939 27.0506 15.2901 27.0322 15.2826C27.0137 15.2751 26.997 15.264 26.9828 15.2501C26.9687 15.2362 26.9575 15.2196 26.9498 15.2014C26.9422 15.1832 26.9382 15.1637 26.9382 15.144C26.9383 15.1042 26.9544 15.0661 26.9829 15.038C27.0114 15.0099 27.0501 14.9941 27.0904 14.9941H29.5111C29.5513 14.9942 29.5899 15.01 29.6184 15.0381C29.6468 15.0662 29.6628 15.1043 29.6629 15.144C29.6629 15.1838 29.6469 15.2219 29.6185 15.25C29.59 15.2781 29.5514 15.2939 29.5111 15.2939Z"
        fill="#94F3F7"
      />
      <Path
        d="M29.5111 15.9491H27.0904C27.0704 15.9492 27.0506 15.9453 27.0322 15.9378C27.0137 15.9303 26.997 15.9193 26.9828 15.9054C26.9687 15.8915 26.9575 15.8749 26.9498 15.8567C26.9422 15.8385 26.9382 15.819 26.9382 15.7993C26.9382 15.7796 26.9422 15.7601 26.9498 15.7419C26.9575 15.7236 26.9687 15.7071 26.9828 15.6932C26.997 15.6793 27.0137 15.6682 27.0322 15.6607C27.0506 15.6532 27.0704 15.6494 27.0904 15.6494H29.5111C29.5514 15.6494 29.59 15.6652 29.6185 15.6933C29.6469 15.7214 29.6629 15.7595 29.6629 15.7993C29.6629 15.839 29.6469 15.8771 29.6185 15.9053C29.59 15.9334 29.5514 15.9491 29.5111 15.9491Z"
        fill="#94F3F7"
      />
      <Path
        d="M29.5111 16.6044H27.0904C27.0501 16.6044 27.0114 16.5886 26.9829 16.5605C26.9544 16.5325 26.9383 16.4943 26.9382 16.4546C26.9382 16.4348 26.9422 16.4153 26.9498 16.3971C26.9575 16.3789 26.9687 16.3624 26.9828 16.3485C26.997 16.3345 27.0137 16.3235 27.0322 16.316C27.0506 16.3085 27.0704 16.3046 27.0904 16.3047H29.5111C29.5514 16.3047 29.59 16.3205 29.6185 16.3486C29.6469 16.3767 29.6629 16.4148 29.6629 16.4546C29.6628 16.4943 29.6468 16.5323 29.6184 16.5604C29.5899 16.5885 29.5513 16.6043 29.5111 16.6044Z"
        fill="#94F3F7"
      />
      <Path
        d="M26.1993 14.2295H23.4518V16.6697H26.1993V14.2295Z"
        fill="#94F3F7"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_1_19167"
          x1="51.622"
          y1="21.2564"
          x2="23.0482"
          y2="15.7928"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="white" />
          <Stop offset="1" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1_19167"
          x1="30822.7"
          y1="1866.74"
          x2="26871.5"
          y2="-4160.31"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="white" />
          <Stop offset="1" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1_19167"
          x1="18988.5"
          y1="10255.2"
          x2="9311.6"
          y2="5959.09"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="white" />
          <Stop offset="1" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1_19167"
          x1="22075.4"
          y1="8038.99"
          x2="25866.7"
          y2="7929.04"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="white" />
          <Stop offset="1" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default FillAddress;
